import React from "react";

const NotEndorsed = () => {
  return (
    <div className="endorsement-banner">
      A career coach has not endorsed you yet. Your profile will not be public
      until you have been approved.
    </div>
  );
};

export default NotEndorsed;
